import { useState } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { ExpenseTable } from "@/components/expenses/ExpenseTable";
import { ExpenseSummaryCards } from "@/components/expenses/ExpenseSummaryCards";
import { RecurringExpensesTab } from "@/components/expenses/RecurringExpensesTab";
import { LoansTab } from "@/components/expenses/LoansTab";
import { TaxesTab } from "@/components/expenses/TaxesTab";
import { useExpenses } from "@/hooks/useExpenses";
import { useTrips } from "@/hooks/useTrips";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Expenses = () => {
  const { expenses, vehicles } = useExpenses();
  const { trips } = useTrips();
  const [selectedVehicleId, setSelectedVehicleId] = useState<string | null>(null);

  const handleVehicleClick = (vehicleId: string) => {
    setSelectedVehicleId((prev) => (prev === vehicleId ? null : vehicleId));
  };

  return (
    <AppLayout>
      <div className="p-4 md:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Expenses</h1>
          <p className="text-muted-foreground mt-1">
            Track and manage your vehicle expenses, recurring costs, and loans
          </p>
        </div>

        <Tabs defaultValue="expenses" className="space-y-6">
          <div className="sticky top-14 md:top-0 z-30 bg-background py-2 -my-2">
            <TabsList>
              <TabsTrigger value="expenses">Expenses</TabsTrigger>
              <TabsTrigger value="recurring">Recurring</TabsTrigger>
              <TabsTrigger value="loans">Loans</TabsTrigger>
              <TabsTrigger value="taxes">Taxes</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="expenses" className="space-y-6">
            <ExpenseSummaryCards
              expenses={expenses}
              vehicles={vehicles}
              trips={trips || []}
              selectedVehicleId={selectedVehicleId}
              onVehicleClick={handleVehicleClick}
            />
            <ExpenseTable highlightVehicleId={selectedVehicleId} />
          </TabsContent>

          <TabsContent value="recurring">
            <RecurringExpensesTab />
          </TabsContent>

          <TabsContent value="loans">
            <LoansTab />
          </TabsContent>

          <TabsContent value="taxes">
            <TaxesTab expenses={expenses} trips={trips || []} vehicles={vehicles} />
          </TabsContent>
        </Tabs>
      </div>
    </AppLayout>
  );
};

export default Expenses;
